var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 23.282L7.99993 20.482L2.26149 22.7025C1.86834 22.8547 1.50424 22.8111 1.16919 22.5718C0.834148 22.3324 0.666626 22.0051 0.666626 21.5897V4.10262C0.666626 3.83937 0.737148 3.60305 0.878193 3.39365C1.01921 3.18425 1.21707 3.03254 1.47176 2.93852L7.99993 0.718018L15.9999 3.51802L21.7384 1.29752C22.1315 1.14538 22.4956 1.18256 22.8307 1.40905C23.1657 1.63554 23.3332 1.95221 23.3332 2.35905V19.9487C23.3332 20.2205 23.2563 20.459 23.1025 20.6641C22.9486 20.8692 22.74 21.0188 22.4768 21.1128L15.9999 23.282ZM15 20.8359V5.23592L8.99989 3.13848V18.7385L15 20.8359ZM16.9999 20.8359L21.3333 19.4V3.60002L16.9999 5.23592V20.8359ZM2.66659 20.4L6.99996 18.7385V3.13848L2.66659 4.60002V20.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.4ac482250a51100dd0d0d19a8bcf6761.svg";
export { ForwardRef as ReactComponent };